var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{
    'qt-loader qt-loader-mini qt-loader-right': _vm.loading,
    'btn-primary': _vm.variant === 'solid',
    'btn-outline-primary': _vm.variant === 'outlined',
  },attrs:{"type":_vm.type},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }